import { render, staticRenderFns } from "./rateCardForm.vue?vue&type=template&id=6466aaf3&scoped=true&"
import script from "./rateCardForm.vue?vue&type=script&lang=js&"
export * from "./rateCardForm.vue?vue&type=script&lang=js&"
import style0 from "./rateCardForm.vue?vue&type=style&index=0&id=6466aaf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466aaf3",
  null
  
)

export default component.exports